import React, {FunctionComponent} from 'react';
import Layout from 'src/components/Layout';
import {FallbackProps} from 'react-error-boundary';

export type Props = FallbackProps & {
  location?: {pathname: string};
};

const ErrorPage: FunctionComponent<Props> = ({location}) => (
  <Layout location={location}>
    <h1>ERROR</h1>
    <p>You just hit an unexpected error... the sadness.</p>
  </Layout>
);

export default ErrorPage;
